import { createIAPComponentOptions } from '@play-co/components';
import type { State } from '../../State';
import {
  catalog,
  catalogLanguages,
  catalogProviders,
  catalogVersion,
} from './iap.catalog';

/**
 * IAP Configuration
 */
export const options = createIAPComponentOptions({
  /**
   * Available providers, first will be default
   */
  providers: catalogProviders,

  /**
   * Available payment methods
   */
  methods: [
    'komoju_paypay',
    'komoju_docomo',
    'komoju_aupay',
    'komoju_credit_card',
    'komoju_softbank',
    'stripe_applePay',
    'stripe_googlePay',
    'komoju_au',
    'komoju_rakutenpay',
    'atone_lite',
    'atone_bnpl',
    'line_app',
  ],

  /**
   * Supported translations, first will be default
   */
  languages: catalogLanguages,

  /**
   * Komoju provider options
   */
  komoju: {
    /**
     * Komoju API key
     */
    publicKey: process.env.KOMOJU_PUBLISHABLE_KEY!,
  },

  /**
   * Atone provider options
   */
  atone: {
    /**
     * Atone API key
     */
    publicKey: process.env.ATONE_PUBLISHABLE_KEY!,

    /**
     * Atone environment, sandbox or production
     */
    environment: process.env.IS_DEVELOPMENT ? 'sandbox' : 'production',

    /**
     * User name for Atone
     */
    userName: (state: State) => state.profile?.name ?? '',
  },

  /**
   * Stripe provider options
   */
  stripe: {
    /**
     * What environment use for Stripe, test or live
     */
    environment: process.env.IS_DEVELOPMENT ? 'test' : 'live',

    /**
     * Stripe publishable key for each environment
     */
    livePublishableKey: process.env.STRIPE_LIVE_PUBLISHABLE_KEY!,
    testPublishableKey: process.env.STRIPE_TEST_PUBLISHABLE_KEY!,
  },

  /**
   * What timezone used for `today` analytics, you can user timezone or have all calculation in game timezone
   */
  setTimezone: () => 'Asia/Tokyo',

  /**
   * What hour considered as the start of the day for `today` analytics
   */
  dayStartHour: 3, // 3:00 AM

  /**
   * Catalog version, if you change items, you should change this version as well
   */
  version: catalogVersion,

  /**
   * Enable cheats for development
   */
  enableCheats:
    process.env.REPLICANT_OFFLINE === 'true' &&
    process.env.IS_DEVELOPMENT === 'true',

  /**
   * Virtual items config
   */
  items: catalog,
});
